import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import { toLocalDateTimeStr } from 'src/shared/utils/localDateTime';
import DummyApi from '../dummyApi';
import { ApprovalDetailDto, ApprovalDto, ApproverDto } from './approvalApi';
const FXM_API_ENABLED = config.servers.fxm.enabled;
const FXM_API_URL = config.servers.fxm.url;
export enum TakeoutStatus {
  TAKEOUT = 'TAKEOUT', // PC 반출
  TAKEIN = 'TAKEIN', //PC 반출 반입
  EXPIRED = 'EXPIRED', // 만료(시스템에 의해)
  NOT_APPLIED = 'NOT_APPLIED', // 정책 서버 미적용 상태, 승인전
}
export interface TakeOutApprovalDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
  approvalNo: string;
  takeoutStatus: string;
}
export type TakeOutApprovalReqDto = Omit<TakeOutApprovalDto, 'approvalNo' | 'takeoutStatus'>;
export interface TakeOutApprovalServerReqDto extends ApprovalDto {
  startDate: number; // 요청 시작 시간
  endDate: number; // 요청 종료 시간
}
export const convertTakeOutApprovalReqDtoToServerReq = (
  reqDto: TakeOutApprovalReqDto
): TakeOutApprovalServerReqDto => {
  return {
    code: reqDto.code,
    approvalStep: reqDto.approvalStep,
    currentStep: reqDto.currentStep,
    approvalType: reqDto.approvalType,
    status: reqDto.status,
    approvalMethod: reqDto.approvalMethod,
    remark: reqDto.remark,
    approvers: reqDto.approvers,
    startDate: reqDto.startDate,
    endDate: reqDto.endDate,
  };
};
export interface TakeOutApprovalDetailDto extends ApprovalDetailDto {
  startDate: number;
  endDate: number;
  takeoutStatus: string;
}
export interface TakeOutApprovalDetailEntity extends TakeOutApprovalDetailDto {
  startDateStr: string;
  endDateStr: string;
  applyDateStr: string;
  updatedTsStr: string;
}
export const toTakeOutApprovalDetailDtoToEntity = (
  dto: TakeOutApprovalDetailDto
): TakeOutApprovalDetailEntity => {
  return {
    ...dto,
    startDateStr: dto.startDate > 0 ? toLocalDateTimeStr(dto.startDate) : '',
    endDateStr: dto.endDate > 0 ? toLocalDateTimeStr(dto.endDate) : '',
    applyDateStr: dto.applyDate > 0 ? toLocalDateTimeStr(dto.applyDate) : '',
    updatedTsStr: dto.updatedTs > 0 ? toLocalDateTimeStr(dto.updatedTs) : '',
    progressApprovers: dto.progressApprovers === null ? [] : dto.progressApprovers,
    completeApprovers: dto.completeApprovers === null ? [] : dto.completeApprovers,
  };
};
interface TakeOutApprovalApi {
  find(code: string): Promise<TakeOutApprovalDetailEntity>;
  apply(reqDto: TakeOutApprovalReqDto): Promise<TakeOutApprovalDto>;
  cancel(approvalNo: string): Promise<boolean>;
  takein(approvalNo: string): Promise<boolean>;
}
class TakeOutApprovalServerApi implements TakeOutApprovalApi {
  async find(code: string): Promise<TakeOutApprovalDetailEntity> {
    const resp = await axios.get<TakeOutApprovalDetailDto>(
      `${FXM_API_URL}/api/takeout/find/${code}`
    );
    return toTakeOutApprovalDetailDtoToEntity(resp.data);
  }
  async apply(reqDto: TakeOutApprovalReqDto): Promise<TakeOutApprovalDto> {
    const serverReqDto: TakeOutApprovalServerReqDto =
      convertTakeOutApprovalReqDtoToServerReq(reqDto);
    const resp = await axios.post<TakeOutApprovalDto>(
      `${FXM_API_URL}/api/takeout/apply`,
      serverReqDto
    );
    return resp.data;
  }
  async cancel(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<TakeOutApprovalDetailDto>(
      `${FXM_API_URL}/api/takeout/cancel/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
  async takein(approvalNo: string): Promise<boolean> {
    const resp = await axios.get<TakeOutApprovalDetailDto>(
      `${FXM_API_URL}/api/takeout/takein/${approvalNo}`
    );
    if ([400, 500].includes(resp.status)) {
      return false;
    }
    return true;
  }
}
const takeOutApprovalApi = new TakeOutApprovalServerApi();
export default takeOutApprovalApi;
